var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('placeholders-form',{attrs:{"submit-loading":_vm.submitLoading,"title":_vm.$t('searchSuggestions.create.title')},on:{"submit":_vm.onSubmit}})}
var staticRenderFns = []

export { render, staticRenderFns }